// extracted by mini-css-extract-plugin
export var actionText = "_s7-4";
export var container = "_s7-0";
export var leftSection = "_s7-1";
export var rightSection = "_s7-2";
export var settingsButton = "_s7-6";
export var settingsIcon = "_s7-7";
export var shortcut = "_s7-5";
export var shortcutGroup = "_s7-3";